import { useCallback, useRef } from "react";

import styled from "styled-components";

import { useMemberToobarContext } from "CrossFeatureComponents/MemberToolbar/MemberToolbarState";
import { contentKeys } from "CrossFeatureComponents/MemberToolbar/contentKeys";
import TwoFA from "Login/TwoFA";

import ActiveContentWrapper from "./ActiveContentWrapper";

const Login = () => {
  const loginWrapperRef = useRef();

  const {
    setActiveContentKey,
    onAuthChange,
    loginVariant,
    tabID,
    accentColor,
    isDark,
    setClickAwayDisabled,
    remoteCancelLoginRef,
  } = useMemberToobarContext();

  const onSuccess = useCallback(
    (payload) => {
      if (onAuthChange) onAuthChange(payload);
      setActiveContentKey(contentKeys.nothing);
      setClickAwayDisabled(false);
    },
    [onAuthChange, setActiveContentKey, setClickAwayDisabled]
  );

  const disabledClickAway = useCallback(() => {
    setClickAwayDisabled(true);
  }, [setClickAwayDisabled]);

  return (
    <ActiveContentWrapper>
      <LoginWrapper
        ref={loginWrapperRef}
        data-cy="MemberToolbar_LoginContainer"
      >
        <TwoFA
          showNetwork={false}
          onSuccess={onSuccess}
          noRedirect
          headerText={false}
          variant={loginVariant}
          tabID={tabID}
          accentColor={accentColor}
          isDark={isDark}
          onInputChange={disabledClickAway}
          remoteCancelRef={remoteCancelLoginRef}
          minHeight="193px"
        />
      </LoginWrapper>
    </ActiveContentWrapper>
  );
};

const LoginWrapper = styled.div`
  max-width: 90vw;
  min-height: 136px;
  align-items: center;
  display: flex;
`;

export default Login;
